import { CONTACTS_COLUMNS } from '../contactsColumnInfo'

/**
 * Columns visible by default in campaign sequence context.
 * Everything else is hidden but available via column selector.
 */
const CAMPAIGN_VISIBLE_COLUMNS = new Set([
  'full_name',
  'first_name',
  'last_name',
  'email_preferred',
  'contact_company',
  'title',
  'seq_membership_status',
  'seq_scheduled_emails',
  'seq_emails_sent',
  'seq_replies',
  'seq_last_email',
  'seq_sequence_step',
])

export const CAMPAIGN_DEFAULT_COLUMN_VISIBILITY = Object.fromEntries(
  Object.keys(CONTACTS_COLUMNS)
    .filter((key) => !CAMPAIGN_VISIBLE_COLUMNS.has(key))
    .map((key) => [key, false])
)
